import { render } from "./UserMaster.vue?vue&type=template&id=7244337a&scoped=true"
import script from "./UserMaster.vue?vue&type=script&lang=js"
export * from "./UserMaster.vue?vue&type=script&lang=js"

import "./UserMaster.vue?vue&type=style&index=0&id=7244337a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7244337a"]])

export default __exports__